import gql from 'graphql-tag'

export const ADD_SUBSCRIBER_MUTATION = gql`
  mutation ($subscriber: AddSubscriberV2Input!) {
    addSubscriberV2(subscriber: $subscriber) {
      id
    }
  }
`

export const GET_SUBSCRIBER_QUERY = gql`
  query ($limit: Int = 5, $offset: Int = 0, $where: subscriber_bool_exp) {
    subscriber(
      offset: $offset
      limit: $limit
      order_by: { created_at: desc }
      where: $where
    ) {
      id
      firstname
      lastname
      email
      zip
      audience_id
      additional_info
      created_at
      tx
      is_active
      audience {
        id
        name
        type
        description
        additional_info
        created_at
      }
      audiences_by_subscribers {
        audienceData {
          name
          id
          type
          description
          additional_info
        }
      }
    }
    subscriber_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

export const REMOVE_SUBSCRIBER_MUTATION = gql`
  mutation ($subscriber: RemoveSubscriberInput!) {
    removeSubscriber(subscriber: $subscriber) {
      affected_rows
    }
  }
`
export const REQUEST_SUBSCRIBER_REMOVAL_MUTATION = gql`
  mutation ($subscriber: RequestSubscriberRemovalInput!) {
    requestSubscriberRemoval(subscriber: $subscriber) {
      success
    }
  }
`

export const EXPORT_CSV_QUERY = gql`
  query {
    exportCsv {
      csv
    }
  }
`

export const GET_SUBSCRIBERS_BY_AUDIENCE = gql`
  query {
    subscribers_by_audience {
      total_cancelations
      total_subscribers
      audience
    }
  }
`

export const GET_SUBSCRIBERS_BY_MONTH_OVER_YEAR = gql`
  query ($year: float8) {
    subscriptions_over_time(where: { Year: { _eq: $year } }) {
      Month
      total_subscribers
    }
  }
`

export const GET_UNSUBSCRIBERS_BY_MONTH_OVER_YEAR = gql`
  query ($year: float8) {
    unsubscriptions_over_time(where: { Year: { _eq: $year } }) {
      Month
      total_subscribers
    }
  }
`

export const GET_SUBSCRIBERS_BY_YEAR = gql`
  query {
    subscriptions_by_year(order_by: { Year: asc }) {
      total
      Year
    }
  }
`

export const GET_UNSUBSCRIBERS_BY_YEAR = gql`
  query {
    unsubscriptions_by_year(order_by: { Year: asc }) {
      total
      Year
    }
  }
`

export const GET_YEARS = gql`
  query {
    subscriptions_by_year(order_by: { Year: asc }) {
      Year
    }
  }
`
